const config = require('../../config.json');

/* ────────────────────────────────────────────────────────────────────────────
   제타트랙 런처(APK) 다운로드 (네이버 클라우드 오브젝트 스토리지)

   항상 최신 빌드(kiosk-latest.apk)를 가리킨다. 서버 환경(config.json 의 service)으로 고른다.
     live              → 라이브 APK
     testserver / dev  → 테스트 APK

   관리자 > 제타트랙 설정의 QR 과 다운로드 페이지(/runningtrack/launcherdownload)가
   이 파일 하나를 같이 본다. 주소를 바꿀 때는 여기만 고친다.
   ──────────────────────────────────────────────────────────────────────────── */
//   ★스토리지의 파일명은 kiosk-latest.apk 그대로다(런처 빌드가 이 이름으로 올라간다).
const LAUNCHER_APK_BASE = 'https://kr.object.ncloudstorage.com/qnoss/runningtrack/version/unity';

export const LAUNCHER_APK = {
  test: { label: '테스트', url: `${LAUNCHER_APK_BASE}/test/apk/kiosk-latest.apk` },
  live: { label: '라이브', url: `${LAUNCHER_APK_BASE}/live/apk/kiosk-latest.apk` },
};

// 다운로드 전에 묻는 비밀번호.
//   ★프런트 번들에 그대로 들어가는 값이라 보안 장치가 아니라 «아무나 받지 않게» 하는 확인 절차다.
//     APK 주소 자체는 공개 링크다.
export const LAUNCHER_APK_PASSWORD = '206977';

export const LAUNCHER_DOWNLOAD_PATH = '/runningtrack/launcherdownload';

//--> 라이브만 라이브 APK, 나머지(테스트·개발)는 테스트 APK.
export const resolveLauncherEnv = () => ((config && config.service) === 'live' ? 'live' : 'test');
